import { render, staticRenderFns } from "./No09.vue?vue&type=template&id=34c605fe&scoped=true"
import script from "./No09.vue?vue&type=script&lang=js"
export * from "./No09.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c605fe",
  null
  
)

export default component.exports